/**
 * Created by swandelow on 29/09/17.
 */
import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {DatePickerRangeComponent} from "./datepicker-range.component";
import {DateInputComponent} from "./date-input/date-input.component";
import {CalendarViewComponent} from "./calendar-view/calendar-view.component";
import {CalendarConfig} from "./calendar-config";
import {DatePickerComponent} from "./datepicker.component";


@NgModule({
    declarations: [
        DatePickerComponent,
        DatePickerRangeComponent,
        DateInputComponent,
        CalendarViewComponent
    ],
    exports: [DatePickerRangeComponent, DatePickerComponent],
    imports: [CommonModule, FormsModule],
    providers: [CalendarConfig]
})
export class DatePickerModule {

}


// WEBPACK FOOTER //
// ./public/upgrade/core/datepicker/datepicker.module.ts